export class Util {
  constructor() {}

  static fetchAndSetData = async (res) => {
    try {
      if (!res) throw res;

      const data = await res.json();
      if (res.status === 200 || res.status === 201) {
        return data;
      } else throw res;
    } catch (e) {
      return false;
    }
  };

  /**
   * @param {Date} value
   * @returns yyyy-mm-dd
   */
  static formatDate = (value) => {
    const date = new Date(value);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  static getDateRange = (startDate, endDate) => {
    const dateRange = [];
    const currentDate = new Date(startDate);

    // endDate를 초과할 때까지 날짜를 배열에 추가
    while (currentDate <= new Date(endDate)) {
      const year = currentDate.getFullYear();
      const month = String(currentDate.getMonth() + 1).padStart(2, "0");
      const day = String(currentDate.getDate()).padStart(2, "0");
      const formattedDate = `${year}-${month}-${day}`;
      dateRange.push(formattedDate);

      // 다음 날짜로 이동
      currentDate.setDate(currentDate.getDate() + 1);
    }

    return dateRange;
  };

  /**
   *
   * @param {*} arr1 배열1
   * @param {*} arr2 배열2
   * @param {*} mergeKey 배열을 합칠 기준의 키
   * @description 서로 다른 배열을 특정키를 통해 하나의 배열로 합치는 함수, 특정 키가 서로 같은 배열은 하나의 객체로 합쳐짐
   * @returns
   */
  static mergeArrays = (arr1 = [], arr2 = [], mergeKey = "") => {
    const combinedArray = arr1.concat(arr2);

    const map = new Map();

    combinedArray.forEach((obj) => {
      const keyValue = obj[mergeKey];
      if (!map.has(keyValue)) {
        map.set(keyValue, obj);
      } else {
        const existingObj = map.get(keyValue);
        const mergedObj = { ...existingObj, ...obj };
        map.set(keyValue, mergedObj);
      }
    });

    return Array.from(map.values());
  };

  static handleKeyPress(event, key, action) {
    if (event.key === key) action();
  }

  static handleCloseOutsideClick = (objRef, handleObjRefClose) => {
    const onClickOutsideCheck = (event) => {
      if (objRef.current && !objRef.current.contains(event.target)) {
        handleObjRefClose(false);
      }
    };

    document.addEventListener("mousedown", onClickOutsideCheck);

    return () => {
      document.removeEventListener("mousedown", onClickOutsideCheck);
    };
  };

  static handleCloseESCKeyPress = (objRef, handleObjRefClose) => {
    const onPressESCKeyCheck = (event) => {
      Util.handleKeyPress(event, "Escape", () => handleObjRefClose(false));
    };

    document.addEventListener("keydown", onPressESCKeyCheck);

    return () => {
      document.removeEventListener("keydown", onPressESCKeyCheck);
    };
  };

  static handleObjectClose = (objRef, handleObjRefClose) => {
    Util.handleCloseOutsideClick(objRef, handleObjRefClose);
    Util.handleCloseESCKeyPress(objRef, handleObjRefClose);
  };
}
